import gql from 'graphql-tag';

const MUTATION_EXPORT_DARKSTORE_REPORT = gql`
    mutation exportDarkstoreReport( $filters: FilterInputPositionsProductData $sendToExport: String ) {
        exportDarkstoreReport(
        filters: $filters
        sendToExport: $sendToExport
        ) {
            internalCode
        }
    }
`;

export default MUTATION_EXPORT_DARKSTORE_REPORT;
